import React, { useEffect, useContext, useState } from "react";
import apiClient from "../../../../api/Api.js";
import { DataContext } from "../../../../context/dataprovider.js";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const Analysis_api = process.env.REACT_APP_ANALYTICS;

const AmountPendingAndAccepted = ({ fromDate, toDate, projectId }) => {
  const { userData = {}, loading, statusDef } = useContext(DataContext);
  const [amountData, setAmountData] = useState({});

  const getAmountPendingAndAcceptedData = async () => {
    try {
      const response = await apiClient.post(`${Analysis_api}/get_amount`, {
        projectId,
        fromDate,
        toDate,
      });
      // console.log(
      //   `Data in AmountPendingAndAccepted: ${JSON.stringify(response.data)}`
      // );
      setAmountData(response.data);
    } catch (error) {
      console.error("Error in Transaction Analysis:", error);
    }
  };

  useEffect(() => {
    getAmountPendingAndAcceptedData();
  }, [loading, projectId, fromDate, toDate]);

  return (
    <TableContainer component={Paper} sx={{ maxWidth: 800, mt: 2, p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Transaction Amounts Per Project
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "bold" }}>Project ID</TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold" }}>
              {statusDef.phase4}
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold" }}>
              {statusDef.final}
            </TableCell>
            <TableCell align="center" sx={{ fontWeight: "bold" }}>
              Total
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(amountData).map(([project, amounts]) => (
            <TableRow key={project}>
              <TableCell>{project}</TableCell>
              <TableCell align="center">
                ₹ {Number(amounts.phase4 || 0).toLocaleString()}
              </TableCell>
              <TableCell align="center">
                ₹ {Number(amounts.final || 0).toLocaleString()}
              </TableCell>
              <TableCell align="center">
                ₹
                {Math.abs(
                  Number(amounts.final || 0) + Number(amounts.phase4 || 0)
                ).toLocaleString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AmountPendingAndAccepted;
